<template>
  <div>
    <router-link class="button is-info is-small" :to="{name: 'Create Pull Out to Client'}">
      <span class="icon">
        <i class="fas fa-plus"></i>
      </span>&nbsp; Create new</router-link>
    &nbsp;
    <button class="button is-small" @click="refreshTable()">Refresh</button>
    <table-pagination :tableData="pullOutToClients.data" :bordered="true" :striped="true" :narrowed="true" :hoverable="true" :mobileCards="true" :loading="isLoadingTable" :page="page" :perPage="perPage" :totalData="pullOutToClients.totalData" @onPageChanged="page = $event" @onSearchChanged="search = $event" @onPerPageChanged="perPage = $event">
      <template slot="row-content" slot-scope="{item}">
        <b-table-column class="table-column-content-is-small" label="ID #">
          {{item.row.pullOutToClientId}}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="Client">
          {{item.row.client}}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="Items">
          {{item.row.item}}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="Date">
          {{item.row.date}}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="Date submitted">
          {{item.row.dateCreated}}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label=" ">
          <button :class="buttonDownloadPullOutToClient" @click="downloadPdf(item.row.pullOutToClientId)" title="Download PDF">
            <span class="icon">
              <i class="far fa-file-pdf"></i>
            </span>
          </button>
          &nbsp;
          <router-link class="button is-small is-warning" :to="{name: 'Edit PullOut to Client', params: { pullOutToClientId:item.row.pullOutToClientId} }">Edit</router-link>
          &nbsp;
          <button class="button is-small is-danger" @click="deletePullOutToClient(item.row.pullOutToClientId)">Delete</button>
        </b-table-column>
      </template>
    </table-pagination>
    <Delete/>
  </div>
</template>

<script>
import axios from 'axios'
import { mapState, mapActions } from 'vuex'
import TablePagination from '../TablePagination.vue'
import Delete from './Delete.vue'
import AppToast from '../frontend/appToast'
import AppButton from '../frontend/appButton'

const appToast = new AppToast()
const appButton = new AppButton()

export default {
  components: {
    TablePagination,
    Delete
  },
  mounted() {
    this.default()
  },
  computed: {
    ...mapState('pullouttoclient', {
      pullOutToClients: state => state.pullOutToClients,
      isLoadingTable: state => state.isLoadingTable
    })
  },
  data: () => ({
    isEmpty: false,
    page: 1,
    perPage: 10,
    search: '',
    buttonDownloadPullOutToClient: appButton.isLoadingDefault(false)
  }),
  methods: {
    ...mapActions('pullouttoclient', [
      'getPaginatedPullOutToClients',
      'openDeleteModal'
    ]),
    downloadPdf(pullOutToClientId) {
      if (pullOutToClientId) {
        this.buttonDownloadPullOutToClient = appButton.isLoadingDefault(true)
        axios
          .get(`downloadables/pullouttoclient?id=${pullOutToClientId}`, {
            responseType: 'blob'
          })
          .then(response => {
            console.log(response.data)
            const windowUrl = window.URL || window.webkitURL;
            const url = windowUrl.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute(
              'download',
              `Pull out to client - ${pullOutToClientId}.pdf`
            )
            document.body.appendChild(link)
            link.click()
          })
          .catch(error => {
            console.log(error)
          })
          .then(
            () =>
              (this.buttonDownloadPullOutToClient = appButton.isLoadingDefault(
                false
              ))
          )
      }
    },
    refreshTable() {
      this.default()
    },
    default() {
      this.getPaginatedPullOutToClients({
        page: this.page,
        pageSize: this.perPage,
        query: this.search
      })
    },
    deletePullOutToClient(id) {
      this.openDeleteModal({
        showDeleteModal: true,
        pullOutToClient: {
          pullOutToClientId: id
        }
      })
    }
  },
  watch: {
    perPage(val) {
      this.getPaginatedPullOutToClients({
        page: this.page,
        pageSize: val,
        query: this.search
      })
    },
    page(val) {
      this.getPaginatedPullOutToClients({
        page: val,
        pageSize: this.perPage,
        query: this.search
      })
    },
    search(val) {
      this.getPaginatedPullOutToClients({
        page: this.page,
        pageSize: this.perPage,
        query: val
      })
    }
  }
}
</script>

